.#{$namespace}-progress {
	display: flex;
	align-items: center;
	line-height: 1;

	&.is-circle,
	&.is-dashboard {
		position: relative;
		display: inline-block;

		.#{$namespace}-progress__text {
			position: absolute;
			inset: 0;
			display: flex;
			align-items: center;
			justify-content: center;
			margin: 0;
		}
	}

	&.is-without-text {
		.#{$namespace}-progress__text {
			display: none;
		}
	}

	&.is-success {
		.#{$namespace}-progress__bar-inner,
		.#{$namespace}-progress__circle-path {
			color: #{color-token(success)};
		}
	}

	&.is-exception {
		.#{$namespace}-progress__bar-inner,
		.#{$namespace}-progress__circle-path {
			color: #{color-token(danger)};
		}
	}

	&.is-warning {
		.#{$namespace}-progress__bar-inner,
		.#{$namespace}-progress__circle-path {
			color: #{color-token(warning)};
		}
	}

	&__bar {
		flex-grow: 1;
		box-sizing: border-box;
	}

	&__bar-outer {
		position: relative;
		overflow: hidden;
		background-color: #{alpha-color($black-color, 6%)};
		border-radius: 100px;
		vertical-align: middle;
	}

	&__bar-inner {
		position: relative;
		height: 100%;
		text-align: right;
		line-height: 1;
		white-space: nowrap;
		background-color: #{color-token(primary)};
		border-radius: 100px;
		transition: width 0.6s ease;

		&.is-striped {
			background-image: linear-gradient(
				45deg,
				#{alpha-color($white-color, 15%)} 25%,
				transparent 25%,
				transparent 50%,
				#{alpha-color($white-color, 15%)} 50%,
				#{alpha-color($white-color, 15%)} 75%,
				transparent 75%,
				transparent
			);
			background-size: 1.25em 1.25em;
		}

		&.is-striped-flow {
			animation: #{$namespace}-progress-striped 3s linear infinite;
		}

		&.is-indeterminate {
			position: absolute;
			top: 0;
			width: auto !important;
			animation: #{$namespace}-progress-indeterminate 3s infinite;
		}
	}

	&__bar-inner-text {
		display: inline-block;
		margin: 0 5px;
		color: $white-color;
		font-size: 12px;
		vertical-align: middle;
	}

	&__circle {
		position: relative;
	}

	&__circle-track {
		color: #{alpha-color($black-color, 6%)};
		stroke: currentColor;
	}

	&__circle-path {
		stroke: #{color-token(primary)};
		transition:
			stroke-dasharray 0.6s ease,
			stroke 0.6s ease;
	}

	&__text {
		margin-left: 10px;
		min-width: 36px;
		color: $text-primary-color;
		font-size: 14px;
		line-height: 1;

		.#{$namespace}-svg {
			display: block;
			font-size: 1.15em;
		}
	}
}

@keyframes #{$namespace}-progress-striped {
	from {
		background-position: 0 0;
	}
	to {
		background-position: 1.25em 0;
	}
}

@keyframes #{$namespace}-progress-indeterminate {
	0% {
		left: -100%;
		width: 50%;
	}
	100% {
		left: 100%;
		width: 50%;
	}
}
